<template>
  <iframe :src="embedUrl" frameborder="0" scrolling="no" width="100%"></iframe>
</template>
<script>
export default {
  name: "story-audio-player",
  props: {
    source: {
      type: String
    }
  },
  data() {
    return {
      embedUrl: false
    };
  },
  watch: {
    source(to, from) {
      if (to && to != from) {
        this.init();
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.source) {
        this.embedUrl = `https://anchor.fm/le-media/embed/episodes/${this.source
          .split("episodes/")
          .pop()}`;
      }
    }
  }
};
</script>
